import { enumService } from "@/common/services/enum";
import { ContractDto, ContractStage } from "@/core/api/generated/v1";

import { StringHelper } from "../string";

export class ContractHelper {
  public static getComputedState(contract: ContractDto | null | undefined) {
    if (!contract) {
      return undefined;
    }

    const deleteAllowedStages: ContractStage[] = [
      ContractStage.Draft,
      ContractStage.Reserved,
      ContractStage.Pending,
      ContractStage.ReservationExpired,
    ];
    const checkOutAllowedStages: ContractStage[] = [
      ContractStage.Draft,
      ContractStage.Reserved,
      ContractStage.Pending,
    ];
    const checkInAllowedStages: ContractStage[] = [ContractStage.Active];

    return {
      confirmAllocation: {
        can: !!contract?.mustConfirmAllocation,
        reason: undefined,
      },
      confirmReservation: {
        can: contract?.stageHistory?.stage === ContractStage.Reserved,
        reason: undefined,
      },
      visualInspectionBeforeCheckOut: {
        can: !!contract?.mustPerformVisualInspectionBeforeCheckOut,
        reason: undefined,
      },
      visualInspectionBeforeCheckIn: {
        can: !!contract?.mustPerformVisualInspectionBeforeCheckIn,
        reason: undefined,
      },
      vehicleCheckOut: {
        can: !!contract?.canCheckOut,
        reason: contract?.canCheckOut
          ? undefined
          : `Check out is allowed only on these stages: ${StringHelper.join(
              checkOutAllowedStages.map((x) => enumService.getEnumValueName("ContractStage", x)),
              ", ",
            )}.`,
      },
      vehicleCheckIn: {
        can: !!contract?.canCheckIn,
        reason: contract?.canCheckIn
          ? undefined
          : `Check in is allowed only on these stages: ${StringHelper.join(
              checkInAllowedStages.map((x) => enumService.getEnumValueName("ContractStage", x)),
              ", ",
            )}.`,
      },
      delete: {
        can:
          !!contract.stageHistory?.stage &&
          deleteAllowedStages.includes(contract.stageHistory?.stage),
        reason: undefined,
      },
    };
  }
}
